import { Component } from '@angular/core';
import {CommonModule} from "@angular/common";
import {FormsModule} from "@angular/forms";
import {AuthenticationService} from "../services/authentication.service";
import {Store} from "@ngrx/store";
import {authActions} from "../../state/auth/auth.actions";
import {settings} from "../../settings/settings";
import * as routeSelectors from "../../state/route/route.selector";

@Component({
  selector: 'binsta-signup',
  standalone: true,
  imports: [FormsModule, CommonModule],
  templateUrl: './signup.component.html',
  styleUrl: `./signup.component.css`,
})
export class SignupComponent {

  email: string = ""
  displayName: string = ""
  password: string = ""
  confirmPassword: string = ""
  returnUrl: string = ""
  apiUrl:string;

  error: string = ""

  constructor(
      private authService: AuthenticationService,
      private store: Store,
  ) {
    let httpProto = "http"
    if (settings.apiTls) {
      httpProto = "https"
    }
    this.apiUrl = `${httpProto}://${settings.apiHost}:${settings.apiPort}`
    this.store.select(routeSelectors.selectQueryParams).subscribe((params) => {
      if(params && "returnUrl" in params) {
        this.returnUrl = params["returnUrl"];
      }
    });
  }

  async register() {
    this.error = ""
    if (this.password !== this.confirmPassword) {
      this.error = "Passwords do not match"
      return
    }
    if (!this.authService.checkPasswordIsSecure(this.password)) {
      this.error = "Password is not secure enough"
      return
    }
    try {
      this.store.dispatch(
          authActions.signupStarted({
            email: this.email,
            username: this.displayName,
            password: this.password,
            returnUrl: this.returnUrl,
          }),
      );
    } catch (e) {
      this.error = e.message
    }
  }
}
